import { store, useRequest } from 'platform-lib-app';
import _ from 'lodash';

const instance = (req) => {
  return useRequest({
    request: (config) => {
      const userStore = store.useUser();
      const subjectInfo = userStore.subjectInfo;
      const subjectShopListCount = subjectInfo?.subjectShopListCount;

      // 业务中，接口配置项中有headers.shopMdCode时，优先取接口配置中的shopMdCode
      const shopMdCode =
        config?.headers?.shopMdCode ||
        (subjectInfo?.subjectShop?.mdCode == 'null' ||
        subjectInfo?.subjectShop?.mdCode == null ||
        !subjectInfo?.subjectShop?.mdCode
          ? 'all'
          : subjectInfo?.subjectShop?.mdCode);

      config.headers['empType'] = subjectInfo?.subject?.subjectTypeSelected?.mValue || '';

      if (subjectShopListCount && subjectShopListCount > 0) {
        config.headers.shopMdCode = shopMdCode || 'all';
      } else {
        config.headers.shopMdCode = config?.headers?.shopMdCode || 'all';
      }
    },
    response: () => {},
  })(req);
};
const http = async config => {
  return await instance(config);
};

export default http;
